import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterRoleprivilegeaction'
})
export class FilterRoleprivilegeactionPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter( it => {
      return it.role_name.toLowerCase().includes(searchText.toLowerCase());

    });
   }

}
